import React, { useEffect, useState } from 'react';
import { Box, Typography, Card, Grid, IconButton } from '@mui/material';
import CustomCalendar from './CustomCalendar';
import KeyboardDoubleArrowUp from '@mui/icons-material/KeyboardDoubleArrowUp';
import KeyboardDoubleArrowDown from '@mui/icons-material/KeyboardDoubleArrowDown';
import { ErrorOutline } from '@mui/icons-material';

const SalesAnalysis = ({ data, Value, title }) => {
  const [selectedMonthIndex, setSelectedMonthIndex] = useState(null);
  const [selectedYearIndex, setSelectedYearIndex] = useState(null);
  const [salesList, setSalesList] = useState([]);

  useEffect(() => {
    if (selectedMonthIndex !== null && selectedYearIndex !== null) {
      const matchedData = data?.find((_item, index) =>
        Value === 'year'
          ? index === selectedYearIndex
          : index === selectedMonthIndex,
      );
      if (matchedData) {
        setSalesList(matchedData.sales_list);
      }
    }
  }, [selectedMonthIndex, selectedYearIndex, data]);

  useEffect(() => {
    if (data && data.length > 0) {
      const lastIndex = data.length - 1;
      setSelectedMonthIndex(lastIndex);
      setSelectedYearIndex(lastIndex);
    }
  }, [data]);

  return (
    <Card
      sx={{
        backgroundColor: '#FFFFFF',
        padding: '10px',
        borderRadius: 2,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        maxWidth: '1200px',
        height: '100%',
      }}
    >
      {data ? (
        <>
          <Typography
            sx={{ fontWeight: '600', textAlign: 'center', fontSize: 18 }}
          >
            {title}
          </Typography>

          <CustomCalendar
            viewType={Value}
            salesData={data}
            setSelectedMonthIndex={setSelectedMonthIndex}
            setSelectedYearIndex={setSelectedYearIndex}
          />
          {salesList.map((item, index) => (
            <Grid
              item
              key={index}
              width={'100%'}
              sx={{
                justifyContent: 'space-between',
                height: '100%',
              }}
            >
              <Box
                display='flex'
                justifyContent='space-between'
                flexDirection='row'
                alignItems='center'
                mt={1}
                sx={{
                  background: '#F6F6F6',
                  padding: '8px',
                  borderRadius: '6px',
                }}
              >
                <Box
                  flexDirection='column'
                  justifyContent='space-between'
                  sx={{ width: '50%' }}
                >
                  <Typography sx={{ fontSize: 14, fontWeight: '500' }}>
                    {item.primary_display_title}
                  </Typography>

                  <Box
                    display='flex'
                    alignItems='center'
                  >
                    {item?.section_footer?.value && (
                      <IconButton
                        size='small'
                        color={
                          item?.section_footer?.type === 'DECREASED'
                            ? 'error'
                            : 'success'
                        }
                      >
                        {item?.section_footer?.type === 'DECREASED' ? (
                          <KeyboardDoubleArrowDown />
                        ) : (
                          <KeyboardDoubleArrowUp />
                        )}
                      </IconButton>
                    )}
                    <Typography
                      sx={{ fontSize: 12, fontWeight: '400', color: '#808080' }}
                      width={'90%'}
                    >
                      {item.section_footer.value} {item.section_footer.label}
                    </Typography>
                  </Box>
                </Box>
                <Typography
                  sx={{
                    fontSize: 14,
                    fontWeight: '600',
                    alignSelf: 'flex-start',
                    color: '#F59C1E',
                  }}
                >
                  {item.prefix_uom} {item.sales} {item.suffix_uom}
                </Typography>
              </Box>
            </Grid>
          ))}
        </>
      ) : (
        <Grid
          container
          justifyContent='center'
          alignItems='center'
          sx={{ height: '100%', minHeight: 200 }}
        >
          <Box textAlign='center'>
            <ErrorOutline sx={{ fontSize: 60, color: '#B2B5C4' }} />
            <Typography
              sx={{ fontSize: 16, fontWeight: 600, color: '#8E92A8', mt: 1 }}
            >
              No Data Found
            </Typography>
          </Box>
        </Grid>
      )}
    </Card>
  );
};

export default SalesAnalysis;
